export default "__VITE_ASSET__833da425__"